import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
// Pages
import LandingPage from './pages/LandingPage/LandingPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import LoginPage from './pages/Login/LoginPage';
import Registration from './pages/Registration/Registration';
import ForgetPassword from './pages/ForgetPassword/ForgetPassword';
import Map from './pages/Map/MapView';
import Nodes from './pages/Noeds/NodePage';
import Users from './pages/User/UsersPage';
// Sidebar
import Sidebar from '../src/components/Sidebar/Sidebar';
import './App.css';

const AppLayout = () => {
  const token = localStorage.getItem('murjan_token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ height: '100vh', width: '100vw', backgroundColor: '#141518', overflow: 'hidden', position: 'relative' }}>
      <Sidebar />
      <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
        <Outlet />
      </div>
    </div>
  );
};

const AdminRoute = () => {
  const storedUser = localStorage.getItem('murjan_user');
  const user = storedUser ? JSON.parse(storedUser) : null;

  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Users />;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES (No Sidebar) */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ForgetPassword />} />

        {/* APP ROUTES (Wrapped inside AppLayout so they get the Sidebar) */}
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/map" element={<Map />} />
          <Route path="/nodes" element={<Nodes />} />
          <Route path="/users" element={<AdminRoute />} />
        </Route>
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
